// Presentation only: API values, customer content and hotel-defined names stay intact.
const COMMON_SPANISH = {
  Reservation: "Reserva", Reservations: "Reservas", Room: "Habitación", Rooms: "Habitaciones",
  "Room Category": "Categoría de habitación", "Room category": "Categoría de habitación",
  "Room Rate": "Tarifa de habitación", "Room rate": "Tarifa de habitación",
  "Room Number": "Número de habitación", "Room number": "Número de habitación",
  "Check-in": "Entrada", "Check-out": "Salida", "Check-In": "Entrada", "Check-Out": "Salida",
  Adults: "Adultos", Children: "Niños", Babies: "Bebés", Nights: "Noches",
  Booker: "Titular de la reserva", "Main Guest": "Huésped principal",
  Floor: "Planta", "Bed type": "Tipo de cama", View: "Vistas",
  "No extras": "Sin extras", "No room rates available.": "No hay tarifas de habitación disponibles.",
  Close: "Cerrar", Cancel: "Cancelar", Save: "Guardar", Confirm: "Confirmar",
  Add: "Añadir", Remove: "Quitar", Edit: "Editar", Delete: "Eliminar", Select: "Seleccionar",
  Yes: "Sí", No: "No", Apply: "Aplicar", Back: "Volver", Next: "Siguiente",
  "Loading...": "Cargando...", "Saving...": "Guardando...", "Calculating...": "Calculando...",
  "Save Extras": "Guardar extras", "Manage Extras": "Gestionar extras",
  Pending: "Pendiente", Draft: "Borrador", Confirmed: "Confirmada", Cancelled: "Cancelada",
  "Checked-in": "Entrada realizada", "Checked-out": "Salida realizada", "No-show": "No presentado",
  Available: "Disponible", Unassigned: "Sin asignar", None: "Ninguno",
};

export function createReservationTranslator(languageId, spanishMessages = {}) {
  return (key, values = {}) => {
    if (key == null) return "";
    const source = String(key);
    const translated = languageId === "es"
      ? (Object.prototype.hasOwnProperty.call(spanishMessages, source)
        ? spanishMessages[source]
        : Object.prototype.hasOwnProperty.call(COMMON_SPANISH, source) ? COMMON_SPANISH[source] : source)
      : source;
    return translated.replace(/\{(\w+)\}/g, (token, name) =>
      Object.prototype.hasOwnProperty.call(values, name) ? String(values[name] ?? "") : token
    );
  };
}

export function getReservationLocale(languageId) {
  return { es: "es-ES", en: "en-GB", ca: "ca-ES" }[languageId] || "en-GB";
}

const SPANISH_STATUSES = {
  draft: "Borrador", pending: "Pendiente", confirmed: "Confirmada",
  cancelled: "Cancelada", canceled: "Cancelada", checked_in: "Entrada realizada",
  checked_out: "Salida realizada", check_in: "Entrada realizada", check_out: "Salida realizada",
  no_show: "No presentado", noshow: "No presentado", paid: "Pagado", unpaid: "Sin pagar",
  partially_paid: "Pagado parcialmente", refunded: "Reembolsado", partially_refunded: "Reembolsado parcialmente",
  failed: "Fallido", succeeded: "Completado", authorized: "Autorizado", captured: "Cobrado",
  released: "Liberado", processing: "En proceso", requires_capture: "Pendiente de cobro",
  requires_action: "Requiere una acción", requires_payment_method: "Requiere un método de pago",
  requires_confirmation: "Pendiente de confirmación", active: "Activo", inactive: "Inactivo",
};

export function translateReservationStatus(status, languageId) {
  if (languageId !== "es" || status == null) return status;
  const key = String(status).trim().toLowerCase().replace(/[\s-]+/g, "_");
  return Object.prototype.hasOwnProperty.call(SPANISH_STATUSES, key) ? SPANISH_STATUSES[key] : status;
}

export function translateReservationModificationBlock(block, languageId) {
  if (!block || languageId !== "es") return block;
  const source = { pms: "PMS / Manual", booking_engine: "Motor de reservas", channel_manager: "Gestor de canales" }[block.originType] || block.originType;
  const actions = { cancellation: "cancelación", dates: "fechas de estancia", guests: "número de huéspedes", room_category: "categoría de habitación", rate_prices: "precios de las tarifas" };
  const denied = (block.deniedActions || []).map((action) => actions[action] || action).join(" y ");
  const message = block.message?.startsWith("Manual modifications")
    ? `Las modificaciones manuales están desactivadas para las reservas de ${source} en Configuración → Configuración de reservas.`
    : `Los cambios de ${denied} están desactivados para las reservas de ${source} en Configuración → Configuración de reservas.`;
  return { ...block, message };
}
